import { Injectable } from '@angular/core';
import { LaunchDarklyInterface } from './launch-darkly.interface';
import { HttpClient } from '@angular/common/http';
import { LDContext, LDFlagSet } from 'launchdarkly-js-client-sdk';

@Injectable({
  providedIn: 'root'
})
export class LaunchDarklyEmergencyTopupService extends LaunchDarklyInterface {
  constructor(public http: HttpClient) {
    super(http);
  }

  initialize(token: string, allowMocks: boolean): Promise<void> {
    return Promise.resolve(undefined); // No-op for emergency topup service
  }

  identify(
    userId: string,
    custom?: { [key: string]: string | number | boolean }
  ): Promise<LDFlagSet> {
    // This prevents any MAU counting in LaunchDarkly
    return Promise.resolve({});
  }

  getCTG88Flag(): string {
    return '';
  }

  getCWDT1119Flag(): boolean {
    return false;
  }

  getCWDT1119VariantFlag(): boolean {
    return false;
  }

  getCWDT1182Flag(): boolean {
    return false;
  }

  getCWDT1182SM1691Flag(): boolean {
    return false;
  }

  getCWDT1187Flag(): boolean {
    return false;
  }

  getCWDT1187VariantFlag(): boolean {
    return false;
  }

  getCWDT1308Flag(): Array<string> {
    return undefined;
  }

  getCWDT1372Flag(): boolean {
    return false;
  }

  getCWDT1376Flag(): boolean {
    return false;
  }

  getCWDT1376SM1612Flag(): boolean {
    return false;
  }

  getCWDT1448Flag(): boolean {
    return false;
  }

  getCWDT1562Flag(): boolean {
    return false;
  }

  getCWDT1562SM1709Flag(): boolean {
    return false;
  }

  getCWDT1847SM1879Flag(): boolean {
    return false;
  }

  getCWDT2108And2417ShowTimeOnTiles(): boolean {
    return false;
  }

  getCWDT2328MoveSMSQuestionFlag(): boolean {
    return false;
  }

  getCWDT24102411HolidayStreakMilestoneModalFlag(): any[] {
    return [];
  }

  getCWDT2433And2434AddTileTooltip(): boolean {
    return false;
  }

  getCWDT2541And2542AddVenmoAndPayPalRewards(): boolean {
    return false;
  }

  getCWDT2647And2648ShowPointsOnTiles(): boolean {
    return false;
  }

  getCWDT803Flag(): boolean {
    return false;
  }

  getGLB723Flag(): boolean {
    return false;
  }

  getPlg161UpdateProfilePointsBanner(): number {
    return 0;
  }

  getRAFFlag(): boolean {
    return false;
  }

  getRW74And76AbilityToSignUpWithAMagicLink(): boolean {
    return false;
  }

  getRW80And104ShowSmsPromptsToUsers(): boolean {
    return false;
  }

  getSDOM358AddVisaGiftCard(): boolean {
    return false;
  }

  getSDOM747MakeMissionSpecialTileFlag(): string[] {
    return [];
  }
}
